import { render, staticRenderFns } from "./loading-table.vue?vue&type=template&id=3938b380&scoped=true&"
import script from "./loading-table.vue?vue&type=script&lang=js&"
export * from "./loading-table.vue?vue&type=script&lang=js&"
import style0 from "./loading-table.vue?vue&type=style&index=0&id=3938b380&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3938b380",
  null
  
)

export default component.exports